import {
    GET_PARENT_CHAT_LIST,
    GET_PARENT_SINGLE_CHAT_VIEW,
    SEND_PARENT_CHAT,
    CLEAR_PARENT_SINGLE_CHAT,
} from "./actionType";

const initialState = {
    chat_list: [],
    chats: [],
    send_parent_chat: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PARENT_CHAT_LIST:
            return { ...state, chat_list: action.payload };
        case GET_PARENT_SINGLE_CHAT_VIEW:
            return { ...state, chats: action.payload };
        case CLEAR_PARENT_SINGLE_CHAT:
            return { ...state, chats: [] };
        case SEND_PARENT_CHAT:
            return { ...state, send_parent_chat: action.payload };
        default:
            return state;
    }
}
